export const SIDE_PAGE_COUNT = 2
export const PAGINATION_SIZE = SIDE_PAGE_COUNT * 2 + 1

export const filterDebounceTimeout = 1000
